import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import { CircularProgressBar } from "components/molecules/CircularProgressBar";
import { Button } from "components/atoms/Button";
import "./index.scss";

interface IProps {
  complete: number;
  inComplete: number;
  upComing: number;
  theme: "light" | "dark";
  styles?: string;
  handleClick?: () => void;
}

export const DoughnutChartCard = ({
  complete,
  inComplete,
  upComing,
  theme,
  styles,
  handleClick,
}: IProps) => {
  return (
    <div
      className={classNames("doughnut-chart-card-container", {
        [`${styles}`]: styles,
      })}
      onClick={handleClick}
    >
      <div className="card-header">
        <Typography variant="h6Bold" label="Overall Progress Summary" />
      </div>
      <div className="chart-section">
        <div className="chart-container">
          <CircularProgressBar
            complete={complete}
            inComplete={inComplete}
            upComing={upComing}
            theme={theme}
            isThreeLayer
          />
        </div>
        <div className="value-container">
          <div className="value-1">
            <div className="incomplete-number">
              <Typography
                variant="h2Med"
                label={`${inComplete}`}
                styles="incomplete-number-custom-style"
              />
            </div>
            <div className="description">
              <Typography
                variant="h9Medium"
                label="Incomplete"
                styles="description-custom-color"
              />
            </div>
          </div>
          <div className="value-2">
            <div className="upcoming-number">
              <Typography
                variant="h2Med"
                label={`${upComing}`}
                styles="upcoming-number-custom-style"
              />
            </div>
            <div className="description">
              <Typography
                variant="h9Medium"
                label="Upcoming"
                styles="description-custom-color"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="button-section">
        <Button
          label="View Progress Summary"
          type="score"
          icon={false}
          styles="doughnut-chart-card-btn"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};
